import { salesEnvironment as env } from './sales.environment';
// env.apiBaseUrl = Config.APIStagingServer;

env.useAuthCookies = true;
export const environment = env;
